<template>
    <div>
        <div class="page-block__overview-link">
            <customer-router-link :to="{ name: 'services' }" class="link-no-decoration | u-flex-center">
                <svg width="16" viewBox="0 0 32 32" class="u-margin-right-inline">
                    <use xlink:href="../assets/icomoon/SVG/icons.svg#arrow-right"></use>
                </svg>
                <strong>{{ trans('page.services.back-to-overview') }}</strong>
            </customer-router-link>
        </div>

        <h1 class="page-block__title | u-font-weight-normal">{{ domain }}</h1>
    </div>
</template>

<script>
export default {
    props: {
        domain: {
            type: String,
            required: true
        }
    }
};
</script>
